// La app guarda los datos de la sesión (usuario, perfil, roles, token) en
// sessionStorage, que es POR PESTAÑA: una pestaña nueva (clic del medio,
// "abrir en otra pestaña") nacía sin usuario y fallaba con "No se pudo
// identificar el usuario actual". Para que la sesión se comparta entre
// pestañas, al iniciar sesión se guarda una copia en localStorage y cada
// pestaña nueva la restaura al arrancar.
//
// La copia solo se restaura si MSAL tiene una cuenta activa (su caché también
// vive en localStorage): después de cerrar sesión no queda cuenta y una
// pestaña nueva no hereda un usuario que ya salió.

const SHARED_PREFIX = "tw-session:";
export const SHARED_SESSION_KEYS = ["profile", "usuarioId", "token", "tokenExpires", "roles"] as const;
type SharedSessionKey = typeof SHARED_SESSION_KEYS[number];

export const setSessionValue = (key: SharedSessionKey, value: string): void => {
  window.sessionStorage.setItem(key, value);
  try {
    window.localStorage.setItem(`${SHARED_PREFIX}${key}`, value);
  } catch {
    // Sin localStorage la sesión sigue funcionando en esta pestaña.
  }
};

export const clearSharedSession = (): void => {
  try {
    SHARED_SESSION_KEYS.forEach((key) => window.localStorage.removeItem(`${SHARED_PREFIX}${key}`));
  } catch {
    // Nada que limpiar si localStorage está bloqueado.
  }
};

export const restoreSharedSession = (hasActiveAccount: boolean): void => {
  try {
    if (!hasActiveAccount) {
      clearSharedSession();
      return;
    }
    if (window.sessionStorage.getItem("usuarioId")) return;
    SHARED_SESSION_KEYS.forEach((key) => {
      const value = window.localStorage.getItem(`${SHARED_PREFIX}${key}`);
      if (value !== null) window.sessionStorage.setItem(key, value);
    });
  } catch {
    // Si el navegador bloquea el storage, la pestaña pedirá login como antes.
  }
};
